export const enum CustomDomEvent {
  tellMeThisThreadIdByDatabase = 'inboxSDKtellMeThisThreadIdByDatabase',
  tellMeThisThreadIdByClick = 'inboxSDKtellMeThisThreadIdByClick',
}
